import React from "react";
import { CancelacionPreliminarGuarderia } from "../../../services/cancelacionesServicios";
import { Badge } from "react-bootstrap";
import { formatearFechaStr } from "../../../utils/dateUtils";

type InfoFechaProgramada = {
    fecha: string,
    fueConsumida: boolean,
    asistio: boolean,
    aCancelar: boolean
}

function FechasCancelacion({ cancelacionPreliminar }: { cancelacionPreliminar: CancelacionPreliminarGuarderia }) {
    const infoFechas = ensamblarInfoFechas(
        cancelacionPreliminar.fechasProgramadas,
        cancelacionPreliminar.fechasConsumidas,
        cancelacionPreliminar.fechasAsistidas,
        cancelacionPreliminar.fechasCancelarAsistencia
    );
    return (
        <div>
            <ol>
                {
                    infoFechas.map(infoFecha => <li key={infoFecha.fecha} className="p-1"><InfoFechaItem infoFecha={infoFecha} /> </li>)
                }
            </ol>
        </div>
    );
}

const InfoFechaItem = ({ infoFecha }: { infoFecha: InfoFechaProgramada }) => {
    return <div className="d-flex gap-2">
        <div>{formatearFechaStr(infoFecha.fecha)}</div>
        {infoFecha.fueConsumida && <Badge bg="primary">Consumida</Badge>}
        {infoFecha.asistio && <Badge bg="secondary">Asistió</Badge>}
        {infoFecha.aCancelar && <Badge bg="danger">A Cancelar</Badge>}
    </div>
}

const ensamblarInfoFechas = (
    fechasProgramadas: Array<string>,
    fechasConsumidas: Array<string>,
    fechasAsistidas: Array<string>,
    fechasCancelar: Array<string>
): Array<InfoFechaProgramada> => {
    const infoFechas: Array<InfoFechaProgramada> = [];
    fechasProgramadas.forEach((fechaProgramada, _) => {
        const fueConsumida = fechasConsumidas.includes(fechaProgramada);
        const asistio = fechasAsistidas.includes(fechaProgramada);
        const aCancelar = fechasCancelar.includes(fechaProgramada);
        infoFechas.push({ fecha: fechaProgramada, fueConsumida, asistio, aCancelar });
    });
    return infoFechas;
};

export default FechasCancelacion;